import React from 'react';
import ScrollReveal from './ScrollReveal';
import '../styles/ExploreApartments.css';

function ExploreApartments({ onApartmentClick }) {
  const apartments = [
    {
      id: 1,
      image: '/assest/images/zebra-1.jpeg',
      title: 'Zebra Suite',
      priceLabel: 'From 200,000 TZS'
    },
    {
      id: 2,
      image: '/assest/images/lion-1.jpeg',
      title: 'Lion Suite',
      priceLabel: 'From 200,000 TZS'
    },
    {
      id: 3,
      image: '/assest/images/tiger-1.jpeg',
      title: 'Tiger Suite',
      priceLabel: 'From 200,000 TZS'
    },
    {
      id: 4,
      image: '/assest/images/suite-a1.jpeg',
      title: 'Garden Suite',
      priceLabel: 'From 200,000 TZS'
    }
  ];

  const handleClick = (apartmentId) => {
    if (onApartmentClick) {
      onApartmentClick(apartmentId);
    }
  };

  return (
    <div className="explore-apartments">
      <div className="explore-container">
        <ScrollReveal className="explore-header" variant="fade-up">
          <h2 className="explore-title">Explore our Apartment</h2>
          <p className="explore-subtitle">Discover your perfect stay in Dar es Salaam</p>
        </ScrollReveal>
        <div className="apartments-grid">
          {apartments.map((apartment, index) => (
            <ScrollReveal
              key={apartment.id}
              variant="scale-in"
              delay={index * 120}
              duration={1100}
            >
              <div
                className="apartment-card"
                onClick={() => handleClick(apartment.id)}
              >
                <div className="apartment-image-wrapper">
                  <img
                    src={apartment.image}
                    alt={apartment.title}
                    className="apartment-image"
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="apartment-overlay" />
                  <div className="apartment-content">
                    <div className="apartment-copy">
                      <h3 className="apartment-title">{apartment.title}</h3>
                      {apartment.priceLabel && (
                        <p className="apartment-price">{apartment.priceLabel}</p>
                      )}
                    </div>
                    <div className="apartment-arrow">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ExploreApartments;
